import { REACT_FRONTEND_ENABLED } from 'src/config/releaseFeatures'
import { useUserStore } from 'src/CrudManager/Core/stores/useUserStore'
import type { RouteRecordRaw } from 'vue-router'

const partsGuard = () => {
  const userStore = useUserStore()
  return userStore.hasPermission('see.reports.inventory') || userStore.hasPermission('transactions.review') ? true : { path: '/' }
}

export const partsDashboardRoutes: RouteRecordRaw[] = [
  REACT_FRONTEND_ENABLED
    ? {
        path: '/dashboard/parts/:partId?',
        redirect: (to) => ({
          path: `/react/dashboard/parts${to.params.partId ? `/${String(to.params.partId)}` : ''}`,
          query: to.query,
          hash: to.hash,
        }),
      }
    : {
        path: '/dashboard/parts/:partId?',
        name: 'parts-dashboard',
        component: () => import('./PartsDashboardPage.vue'),
        meta: { title: 'Pièces', requiresAuth: true },
        beforeEnter: partsGuard,
      },
  // The parts-to-order queue is a Vue page of its own in both release states.
  {
    path: '/parts-to-order',
    name: 'parts-to-order',
    component: () => import('./PartsToOrderPage.vue'),
    meta: {
      title: 'Pièces à commander',
      requiresAuth: true,
    },
    // Either grant opens the page; what it shows depends on which one. The
    // endpoints still enforce their own grants — this only spares the dead end.
    beforeEnter: () => {
      const userStore = useUserStore()
      if (!userStore.hasPermission('transactions.review') && !userStore.hasPermission('parts-orders.create')) {
        return { path: '/' }
      }
      return true
    },
  },
  REACT_FRONTEND_ENABLED
    ? { path: '/parts/unsold', redirect: { path: '/react/dashboard/parts', query: { lens: 'never_sold' } } }
    : {
        path: '/parts/unsold',
        redirect: (to) => ({ path: '/dashboard/parts', query: { ...to.query, lens: 'never_sold' }, hash: to.hash }),
      },
]

export default partsDashboardRoutes
